import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import CustomInput from "../../custom/custom-input/CustomInput";
import CustomInputWithUnits from "../../custom/custom-input-with-units/CustomInputWithUnits";
import CustomTextarea from "../../custom/custom-textarea/CustomTextarea";
import CustomSelect from "../../custom/custom-select";
import CustomUploadFileMultiple from "./custom-upload/CustomUploadFileMultiple";
import { CreationCard, CreationToggle } from "../../orders/unified-create/OrderCreationControls";
import OrderCreationInfoIcon from "../../shared/icons/OrderCreationInfoIcon";
import { INCOTERMS_CODES } from "../../../pages/orders/utils/newOrderPayload";
import { WEIGHT_UNITS } from "../../../mock";
import styles from "./AviationOrderDetails.module.scss";

const INCOTERMS = INCOTERMS_CODES.map((code) => ({ id: code, name: code }));

export default function AviationOrderDetails(p) {
  const { t } = useTranslation();
  const user = useSelector((state) => state.user);
  const { errors = {} } = p;
  return (
    <CreationCard title={t("ordersCreateDesktop.detailsSection.title")} counter={3}>
      <div className={styles.cargoFields}>
        <CustomInput
          labelText={`${t("ordersCreateDesktop.detailsSection.categoryLabel")}*`}
          placeholder={t("ordersCreateDesktop.detailsSection.categoryPlaceholder")}
          inputType="text"
          isBgGray
          value={p.categoryName}
          onChangeValue={p.setCategoryName}
          errorText={errors.categoryName}
        />
        <CustomInput
          labelText={t("ordersCreateDesktop.detailsSection.volumeLabel")}
          inputType="number"
          isBgGray
          value={p.volume}
          onChangeValue={p.setVolume}
          errorText={errors.volume}
          prefixEnd={
            <span>
              {t("ordersCreateDesktop.detailsSection.volumeUnit")}
              <sup>3</sup>
            </span>
          }
        />
        <CustomInputWithUnits
          labelText={t("ordersCreateDesktop.detailsSection.weightLabel")}
          inputType="number"
          isBgGray
          value={p.weight}
          onChangeValue={p.setWeight}
          errorText={errors.weight}
          units={WEIGHT_UNITS(t)}
          selectedUnit={p.unitMeasurement === "Ton" ? "ton" : "kg"}
          onChangeUnit={(unit) => p.setUnitMeasurement(unit.code)}
        />
      </div>
      <CustomInput
        labelText={t("bulkCreate.fields.tnved")}
        placeholder={t("unifiedOrder.tnvedPlaceholder")}
        inputType="text"
        isBgGray
        value={p.tnvedCode}
        onChangeValue={p.setTnvedCode}
      />
      <CustomTextarea
        placeholder={t("comment.placeholder")}
        labelText={t("comment.label")}
        inputType="text"
        isBgGray
        value={p.details}
        onChangeValue={p.setDetails}
      />
      <div className={styles.options}>
        <CustomUploadFileMultiple
          user={user}
          files={p.files}
          onUploadFiles={p.setFiles}
          serverFiles={p.serverFiles}
          onDeleteServerFile={p.onDeleteServerFile}
          title={t("unifiedOrder.documents")}
        />
        <div hidden className={styles.insurance}>
          <CreationToggle
            title={t("unifiedOrder.insurance")}
            description={t("cargoInsurance.insuranceCostInfo3")}
            icon={OrderCreationInfoIcon}
            checked={Boolean(p.insurance)}
            onChange={p.queryInsurance}
          />
        </div>
        <div className={styles.incoterms}>
          <CreationToggle
            title={t("unifiedOrder.incotermsTitle")}
            description={t("unifiedOrder.incotermsDescription")}
            icon={OrderCreationInfoIcon}
            checked={p.incotermsEnabled}
            onChange={p.setIncotermsEnabled}
          />
          {p.incotermsEnabled && (
            <CustomSelect
              labelText={t("unifiedOrder.incotermsLabel")}
              placeholder={t("unifiedOrder.incotermsPlaceholder")}
              options={INCOTERMS}
              defaultValue={INCOTERMS.find((item) => item.id === p.incoterms)}
              onSubmit={p.setIncoterms}
              errorText={errors.incoterms}
            />
          )}
        </div>
      </div>
    </CreationCard>
  );
}
